/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Step_2_BodyInputs */

const da_forside_step_2_body = /** @type {(inputs: Forside_Step_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eleverne har kun nummer og alias. Før upload dækker du navne med sorte felter – kun den dækkede version forlader din computer.`)
};

/** @type {(inputs: Forside_Step_2_BodyInputs) => LocalizedString} */
const en_forside_step_2_body = da_forside_step_2_body;

/**

* @param {Forside_Step_2_BodyInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_step_2_body = /** @type {((inputs?: Forside_Step_2_BodyInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Step_2_BodyInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_step_2_body(inputs)
	return /** @type {LocalizedString} */ ("Eleverne har kun nummer og alias. Før upload dækker du navne med sorte felter – kun den dækkede version forlader din computer.")
});